import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../api/ApiService';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;

    &.black-note {
      color: rgba(0, 27, 59, 0.94);
    }
  }
`;

const Formula = styled.div`
  margin-top: 12px;
  max-width: 714px;
  background: #ffffff;
  border: 1px solid #d5d9dd;
  border-radius: 8px;
  padding: 16px;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

const Red = styled.span`
  color: #ec5e59;
`;

const Cyan = styled.span`
  color: #55b4bc;
`;

const Yellow = styled.span`
  color: #eca427;
`;

class HowGradingWorksStep5 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      gradingWeights: {},
      loaded: false
    };
  }

  componentDidMount() {
    getRequest(`${process.env.REACT_APP_API_URL}v2/games/gradingweights/`)
      .then(res => {
        const gradingWeights = res.body.results[0];

        this.setState({
          gradingWeights,
          loaded: true
        });
      })
      .catch(err => { });
  }
  render() {
    const { gradingWeights, loaded } = this.state;

    return loaded ? (
      <Wrapper>
        <Container>
          <Text1>How Grading Works</Text1>
          <Text2>Individual Score</Text2>
          <Text3>
            Here's how each of the factors drive a students' score.
          </Text3>

          <Formula>
            Individual Score = <Red>(Team Score * {Number(gradingWeights.team_grade).toFixed(2)})</Red> + <Cyan>(Peer Rating Score * {Number(gradingWeights.peer_weight).toFixed(2)})</Cyan> + <Yellow>(Engagement Score * {Number(gradingWeights.engagement_score).toFixed(2)})</Yellow>
          </Formula>

          <Text3>
            That's all for grading. To learn more, you'll need to navigate
            to the <b>Game Admin</b> section. Let's move on to What to
            Expect in each round.
          </Text3>
        </Container>
      </Wrapper>
    ) : (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    );
  }
}

export default HowGradingWorksStep5;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/how-grading-works/step5.js